import React from "react";
import { Box, FormHelperText, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

import { fieldStyles } from "../../styles";
import { NotesProps } from "./types";

export const Notes: React.FC<NotesProps> = ({
  control,
  notesError,
  setNotesError,
}) => (
  <Box sx={fieldStyles.notesContainer}>
    <Controller
      name="notes"
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          size="small"
          label="Notes"
          multiline
          rows={3}
          error={notesError}
          sx={fieldStyles.multilineTextField}
          helperText={
            notesError ? (
              <FormHelperText sx={fieldStyles.errorHelperText}>
                Notes length should not exceed 250 characters
              </FormHelperText>
            ) : ""
          }
          onChange={(e) => {
            const { value } = e.target;
            if (value.length <= 250) {
              setNotesError(false);
              field.onChange(value);
            } else {
              setNotesError(true);
            }
          }}
        />
      )}
    />
  </Box>
);
